import script from "./CommitmentPact.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommitmentPact.vue?vue&type=script&setup=true&lang=ts"

import "./CommitmentPact.vue?vue&type=style&index=0&id=0bc7df53&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc7df53"]])

export default __exports__